import { camelCase } from 'es-toolkit/string';
import { VehicleDepartureErrorCodec } from '../../api/types/compoundManagement/errorCodes';
import { ProblemCodec } from '../../api/types/problemApi.types';
import { handleQueryError, isErrorResponse, showErrorNotification } from '../../notifications/ErrorNotification';

const departureMessageIdPrefix = 'outboundOrderBook.compoundManagement.notification.outgoingVehicle.confirmDeparture.';

export const handleDepartureCompletionError = (error: unknown) => {
    if (isErrorResponse(error, VehicleDepartureErrorCodec)) {
        showErrorNotification(departureMessageIdPrefix + `${camelCase(error.data.error_code)}`, {
            vin: error.data.vin,
        });
        return;
    }
    if (isErrorResponse(error, ProblemCodec) && error.status === 400) {
        showErrorNotification('outboundOrderBook.compoundManagement.bulkStatusUpdate.validationError');
    } else {
        handleQueryError(error);
    }
};
